module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-content"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "headerLeft"
  }, [_c('div', {
    staticClass: "startDate"
  }, [_c('el-date-picker', {
    attrs: {
      "size": "small",
      "type": "date",
      "placeholder": "开始日期",
      "picker-options": _vm.getSTime1Fun
    },
    on: {
      "change": _vm.getSTime1
    },
    model: {
      value: (_vm.date1),
      callback: function($$v) {
        _vm.date1 = $$v
      },
      expression: "date1"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "endDate"
  }, [_c('el-date-picker', {
    attrs: {
      "size": "small",
      "type": "date",
      "placeholder": "结束日期",
      "picker-options": _vm.getSTime2Fun
    },
    on: {
      "change": _vm.getSTime2
    },
    model: {
      value: (_vm.date2),
      callback: function($$v) {
        _vm.date2 = $$v
      },
      expression: "date2"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "fun"
  }, [_c('el-row', [_c('el-button', {
    staticClass: "search",
    attrs: {
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.search()
      }
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', {
    staticClass: "deltale",
    attrs: {
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.deltale()
      }
    }
  }, [_vm._v("清除")]), _vm._v(" "), _c('el-button', {
    staticClass: "doexcel",
    attrs: {
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.doexcel()
      }
    }
  }, [_vm._v("导出")])], 1)], 1)]), _vm._v(" "), _c('el-table', {
    staticClass: "loadingPrivate",
    staticStyle: {
      "width": "100%,font-size:0.5rem,margin-bottom:1rem"
    },
    attrs: {
      "max-height": "500",
      "data": _vm.tableData
    }
  }, [_c('el-table-column', {
    staticClass: "staff",
    attrs: {
      "label": "关注"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "attentionTotal",
      "label": "关注总数",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "attentionAdd",
      "label": "累计关注人数",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "attentionCancel",
      "label": "累计取关人数",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "addUser",
      "label": "净增关注人数",
      "width": "120"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    staticClass: "staff",
    attrs: {
      "label": "注册"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "registerTotal",
      "label": "注册总数",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "registerEmployee",
      "label": "合众员工",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "registerEmployeeRatio",
      "label": "合众员工占比",
      "width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "registerCustomer",
      "label": "寿险用户",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "registerCustomerRatio",
      "label": "寿险用户占比",
      "width": "120"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    staticClass: "staff",
    attrs: {
      "label": "开户"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "openTotal",
      "label": "开户总数",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "openEmployee",
      "label": "合众员工",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "openEmployeeRatio",
      "label": "合众员工占比",
      "width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "openCustomer",
      "label": "寿险用户",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "openCustomerRatio",
      "label": "寿险用户占比",
      "width": "120"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    staticClass: "client",
    attrs: {
      "label": "转化率"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "attentionRegisterRation",
      "label": "平台关注~注册转化率",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "registerOpenRation",
      "label": "平台注册~开户转化率",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "registerEmployeeOpenRation",
      "label": "合众员工注册~开户转化率",
      "width": "190"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "registerCustomerOpenRation",
      "label": "寿险用户注册~开户转化率",
      "width": "190"
    }
  })], 1)], 1), _vm._v(" "), (_vm.isPage) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage1,
      "page-size": 15,
      "layout": " prev, pager, next",
      "total": _vm.totalCount
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage1 = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage1 = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pagNum"
  }, [_vm._v("共" + _vm._s(_vm.pagNum) + "页 （共" + _vm._s(_vm.totalCount) + "条）")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a3854c4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/page/client2.vue
// module id = 3223
// module chunks = 1